module.exports = __webpack_public_path__ + "assets/img/10-m.748bee8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/10-m.jpg
// module id = 1+c0
// module chunks = 0